






















































import Vue                      from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import {Column, Dictionary}     from '@/types'
import {prop, resolve}          from '@/common/helpers'

@Component
export default class Datatable extends Vue {
    @Prop({type: Array as () => Column[]})
    protected columns!: Column[]

    @Prop(String)
    protected actionsText !: string

    @Prop(prop(Array, []))
    protected rows!: any[]

    @Prop(prop(Number, 10))
    protected pageSize!: number

    @Prop(prop(String, 'Nenhum dado a ser exibido.'))
    protected placeholder!: string

    @Prop(Boolean)
    protected printButton!: boolean

    protected currentPage: number = 1
    protected totalPages: number = 0
    protected mobile: boolean = false
    protected loading: boolean = false

    constructor(...args: any) {
        super(...args)

        this.checkWidth = this.checkWidth.bind(this)
        this.processScroll = this.processScroll.bind(this)
    }

    public resetPage() {
        this.currentPage = 1
    }

    protected resolve(column: Dictionary, row: Dictionary) {
        const {field, render} = column
        const data = resolve(row, field)

        if ('function' === typeof render) {
            return render(data, row)
        }

        return data
    }

    protected get hasActions() {
        return !!this.$slots.actions
            || !!this.$scopedSlots.actions
    }

    protected get hasCFC() {
        return !!this.$slots.cfc
            || !!this.$scopedSlots.cfc
    }

    protected get numCols(): number {
        const {columns} = this

        if (!columns) {
            return 0
        }

        return this.columns.length
            + (this.hasActions ? 1 : 0)
            + (this.printButton ? 1 : 0)
    }

    protected get numRows() {
        const {rows} = this
        return rows ? rows.length : 0
    }

    protected get currentPageSize() {
        if (this.mobile) {
            return null
        }
        return this.pageSize
    }

    @Watch('currentPage')
    protected atLastPage(v: number) {
        if (v === this.totalPages) {
            this.lastPageHandler()
        }
    }

    @Watch('totalPages')
    protected totalPagesChanged(v: number) {
        if (v < this.currentPage) {
            this.currentPage = 1
        }
    }

    @Watch('mobile')
    protected mobileChanged(mobile: boolean) {
        document.body.onscroll = mobile ? this.processScroll : null
    }

    protected checkWidth() {
        const {offsetWidth: width} = document.body
        this.mobile = width <= 768
    }

    protected processScroll() {
        if (this.loading) {
            return
        }

        const table = this.$el.querySelector('table') as HTMLTableElement
        const additional = table.offsetTop
        const currentScroll = window.scrollY + additional

        if (table.offsetHeight - currentScroll < 500) {
            this.lastPageHandler()
        }
    }

    protected lastPageHandler() {
        this.$emit('last-page', (loading: boolean) => {
            this.loading = loading
        })
    }

    protected mounted() {
        document.body.onresize = this.checkWidth
        this.checkWidth()
    }
}
